"use strict";
var modal_window_controller_1 = require("./modal-window.controller");
var templateUrl = require("./modal-window.html");
exports.modalWindow = {
    templateUrl: templateUrl,
    controller: modal_window_controller_1.ModalWindowController,
    controllerAs: "vm",
    bindToController: true,
    scope: {}
};



/** WEBPACK FOOTER **
 ** ./app/common/modal-window/modal-window.ts
 **/